// extracted by mini-css-extract-plugin
export var active = "MyAccountNav_active__U5uSz";
export var nav = "MyAccountNav_nav__qCbsl";
export var navContainer = "MyAccountNav_navContainer__zuzAE";
export var tab = "MyAccountNav_tab__669bo";